import Vue from "vue";
import App from "@/App.vue";
import vuetify from "@/lib/vuetify";
import store from "@/store";
import router from "@/router";
import vClickOutside from "@/plugins/click-outside";
import "@/lib/vue-moment.js";
import "@/filters";

Vue.config.productionTip = false;

Vue.use(vClickOutside);

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount("#app");
